import { BUNDLE_AVATAR_COLORS } from "../../utils/variables/common"
import { getInitials } from "../../utils/parsers/common"

const CustomersCell = ({ customers, onOpen }) => {
  return (
    <button
      className="flex items-center gap-1.5 group/c"
      onClick={(e) => {
        e.stopPropagation()
        onOpen(customers)
      }}
    >
      <div className="flex -space-x-2">
        {customers.slice(0, 3).map((c, i) => (
          <div
            key={i}
            className={`w-6 h-6 rounded-full border-2 border-white flex items-center justify-center text-[9px] font-bold ${BUNDLE_AVATAR_COLORS[i % BUNDLE_AVATAR_COLORS.length]}`}
          >
            {getInitials(c.name)}
          </div>
        ))}
        {customers.length > 3 && (
          <div className="w-6 h-6 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center text-[9px] font-bold text-gray-500">
            +{customers.length - 3}
          </div>
        )}
      </div>
      <span className="text-[11px] text-gray-400 group-hover/c:text-blue-500 transition-colors whitespace-nowrap">
        {customers.length} ос.
      </span>
    </button>
  )
}

export default CustomersCell
